import { Routes, Route, Navigate } from 'react-router-dom';
import type { Case } from '../../types';
import SubTabBar from '../../components/SubTabBar';
import DemandLetterTab from '../../components/tabs/DemandLetterTab';
import InventoryAppraisementTab from '../../components/tabs/InventoryAppraisementTab';
import ReportsTab from '../../components/tabs/ReportsTab';
import ChildSupportTab from '../../components/tabs/ChildSupportTab';
import TrialPackTab from '../../components/tabs/TrialPackTab';

interface Props {
  caseData: Case;
}

export default function DraftsSection({ caseData }: Props) {
  const caseId = caseData.public_id;

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <SubTabBar
        basePath={`/cases/${caseData.public_id}/drafts`}
        tabs={[
          { to: 'letters', label: 'Demand Letters' },
          { to: 'inventory', label: 'Inventory & Appraisement' },
          { to: 'reports', label: 'Reports' },
          { to: 'child-support', label: 'Child Support' },
          { to: 'trial-pack', label: 'Trial Pack' },
        ]}
      />
      <div className="flex-1 overflow-y-auto [scrollbar-gutter:stable] p-6">
        <Routes>
          <Route path="letters" element={<DemandLetterTab caseId={caseId} caseData={caseData} />} />
          <Route path="inventory" element={<InventoryAppraisementTab caseId={caseId} />} />
          <Route path="reports" element={<ReportsTab caseId={caseId} clientName={caseData.client_name} opposingPartyName={caseData.opposing_party_name} />} />
          <Route path="child-support" element={<ChildSupportTab caseId={caseId} caseData={caseData} />} />
          <Route
            path="trial-pack"
            element={
              <TrialPackTab
                caseId={caseId}
                clientName={caseData.client_name}
                opposingPartyName={caseData.opposing_party_name}
              />
            }
          />
          {/* Absolute path — see InvestigationSection: relative `to` under a splat loops. */}
          <Route path="*" element={<Navigate to={`/cases/${caseData.public_id}/drafts/letters`} replace />} />
        </Routes>
      </div>
    </div>
  );
}
